import React from 'react';
import PropTypes from 'prop-types';
import AdminModal from '../common/AdminModal';

export default function ApiTokenRevealModal({ show, token, onClose }) {
  if (!show || !token) return null;

  const copyToken = async () => {
    try {
      await navigator.clipboard.writeText(token);
    } catch {
      // clipboard may be unavailable in tests
    }
  };

  const footer = (
    <div className="d-flex justify-content-end w-100">
      <button type="button" className="btn btn-primary" onClick={onClose}>
        I have saved the token
      </button>
    </div>
  );

  return (
    <AdminModal show={show} onClose={onClose} title="Save your API token" footer={footer} size="">
      <div className="alert alert-warning mb-3">
        <i className="bi bi-exclamation-triangle me-2" />
        Copy this token now. It will not be shown again.
      </div>
      <label htmlFor="api-token-reveal" className="form-label">API token</label>
      <div className="input-group">
        <input id="api-token-reveal" type="text" className="form-control font-monospace" readOnly value={token} />
        <button type="button" className="btn btn-outline-secondary" onClick={copyToken}>
          Copy
        </button>
      </div>
    </AdminModal>
  );
}

ApiTokenRevealModal.propTypes = {
  show: PropTypes.bool.isRequired,
  token: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

ApiTokenRevealModal.defaultProps = {
  token: null,
};
